const checkDevice = () => {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = window.navigator.userAgent.toLocaleLowerCase();
    if (userAgent.includes('android')) return 'Android';
    else if (
      userAgent.includes('iphone') ||
      userAgent.includes('ipad') ||
      userAgent.includes('ipod')
    )
      return 'IOS';
  }
  return 'Web';
};

export default checkDevice;
